define(function (require) {
    "use strict";

    var LE = require("app");
    var Logger = require("logger");
    var template = require("manager-templates/manageDomains.tmpl");
    var Button = require("ui/button/Button");
    var InputField = require("ui/input-field/InputField");
    var ToggleButton = require("ui/toggle-button/toggleButton");
    var ManageDomainsBoxView = require("manager-views/ManageDomainsBoxView");
    var ManageDomainsModel = require("manager-models/ManageDomainsModel");
    var ManageDomainsBoxItemModel = require("manager-models/ManageDomainsBoxItemModel");

    var ManageDomainsView = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {

        ManageDomainsView = Marionette.Layout.extend({
            className: "manage-domains",
            template: template,
            regions : {
                toggleContainer: ".toggle-container",
                whitelistContainer: ".whitelist-container",
                blacklistContainer: ".blacklist-container"
            },
            ui: {
                toggleContainer: ".toggle-container",
                whitelistContainer: ".whitelist-container",
                blacklistContainer: ".blacklist-container",
                cancelButton: ".cancel-button",
                saveButton: ".save-button"
            },
            uiComponents: {
                manageDomainsEnabled: {
                    type: ToggleButton,
                    options: {
                        container: "view.ui.toggleContainer",
                        transition: ToggleButton.TRANSITION.FAST
                    },
                    events: {
                        "toggleButton:change": "_setManageDomainsToggleButton"
                    }
                },
                cancelButton: {
                    type: Button,
                    options: {
                        el: "view.ui.cancelButton",
                        permutation: Button.PERMUTATION.LINK
                    },
                    events: {
                        "click": "_onCancel"
                    }
                },
                saveButton: {
                    type: Button,
                    options: {
                        el: "view.ui.saveButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY,
                        initState: Button.STATES.DISABLED,
                        tooltipAlign: Button.TOOLTIP_ALIGN.RIGHT,
                        tooltip: LE.translator.translate("LEManager.manage.domains.disable.saveButton")
                    },
                    events: {
                        "click": "_onSave"
                    }
                }
            },
            modelEvents: {
                "change": "_onManageDomainModelChanged"
            },

            //<editor-fold desc="Marionette-Functions">
            /*-----------------------------------------------------------------------------------------------*/
            initialize: function(options) {
                this._initialize(options);
            },
            onRender: function() {
                this._onRender();
            },
            onClose: function() {
                LEManager.logger.debug("Manage domains view is closed. re-init it.", "ManageDomainsView:onClose");
            },
            //</editor-fold>

            //<editor-fold desc="publicFunctions">
            /*-----------------------------------------------------------------------------------------------*/
            //</editor-fold>

            //<editor-fold desc="privateFunctions">
            /*-----------------------------------------------------------------------------------------------*/
            _initialize: function(options) {
                LEManager.logger.info("initializing", "ManageDomainsView:_initialize. options = " + options);
                this.logger = Logger.getLogger("LEManager");
                this.channel = LEManager.media.channel("manageDomains");
            },

            _onRender: function() {
                LEManager.logger.info("rendering", "ManageDomainsView:_onRender.");
                this._bindEvents();
                this.uiComponents.manageDomainsEnabled.setChecked(this.model.get(ManageDomainsModel.KEYS.ENABLED));
                this._onManageDomainModelChanged({isInit: true});
                this.whiteListView = new ManageDomainsBoxView({ collection: this.model.whitelistCollection, type: ManageDomainsBoxView.TYPE.WHITE});
                this.whitelistContainer.show(this.whiteListView);
                this.blackListView = new ManageDomainsBoxView({ collection: this.model.blacklistCollection, type: ManageDomainsBoxView.TYPE.BLACK});
                this.blacklistContainer.show(this.blackListView);
            },

            _bindEvents: function() {
                LEManager.logger.debug("Init events to the view", "ManageDomainsView:_onRender.");
                this.listenTo(this.channel, "manageDomain:changed", this._updateManageDomainsData);
                this.listenTo(this, "page:closeButtonClick", this._onCancel); // for X
            },
            _updateManageDomainsData: function () {
                this.model.setManageDomainsData();
            },
            _setManageDomainsToggleButton: function () {
                this.model.setEnabled(this.uiComponents.manageDomainsEnabled.isChecked());
            },

            _onManageDomainModelChanged : function (toggleButton) {
                if(this.model.whitelistCollection.isEmpty() && this.model.blacklistCollection.isEmpty() && this.uiComponents.manageDomainsEnabled.isChecked() && _.has(toggleButton.changed, "enabled")){
                    this.uiComponents.saveButton.setTooltip(LE.translator.translate("LEManager.manage.domains.onPublish.disable.saveButton"));
                    this.uiComponents.saveButton.setEnabled(false);
                }else{
                    if(this.model.whitelistCollection.isEmpty() && this.model.blacklistCollection.isEmpty()) {
                        this.uiComponents.manageDomainsEnabled.setChecked(false);
                        this._setManageDomainsToggleButton();
                    }
                    if(!toggleButton.isInit) {
                        this.uiComponents.saveButton.setEnabled(true);
                        this.uiComponents.saveButton.setTooltip("");
                    }
                }
            },

            _onCancel: function() {
                this.channel.trigger("manageDomains:page:close");
            },

            _onSave: function() {
                LEManager.logger.debug("Try to save form", "ManageDomainsView:_onManageDomainsEnabledChange.");
                this.channel.trigger("manageDomains:save");
            }
            //</editor-fold>
        });
    }

    LE.module("LEManager", moduleDefinition);

    return ManageDomainsView;

});
